@use '../../scss/utility';

:host {
  display: flex;
  align-items: center;
  margin-inline-start: utility.wb-pixel-to-rem(16px);
  margin-inline-end: utility.wb-pixel-to-rem(16px);

  @include utility.breakpoint-from(mq5) {
    margin-inline-start: 0;
  }
}
